export default __webpack_public_path__ + "media/components/Pages/Index/Images/Profs-45302ea6945d877fbbd029e85544a89c.svg";